import React from "react";
import {Empty, Skeleton} from "antd";
import PresentationListItem from "./components/PresentationListItem";
import PresentationModal from "../../../../components/modals/presentation-modal/PresentationModal";
import {usePresentationController} from "../../../../controllers/presentationItems-controller";
import AddActionButton from "../../../../components/action-buttons/addAction-button/AddActionButton";
import "./style.less"
import {useAuth} from "../../../../context/authContext";


const PresentationList: React.FC = () => {
  const {canManageContent} = useAuth()
  const presentationController = usePresentationController()
  const {presentationItems, isLoading, isPresentationModalOpen} = presentationController
  return (
    <section className="presentation_list" aria-labelledby="about-hospital-title">
      <header className="presentationList_intro">
        <div>
          <div className="home-section-heading__eyebrow">Про лікарню</div>
          <h2 className="home-section-heading__title" id="about-hospital-title">Допомагаємо людям щодня</h2>
          <p className="presentationList_intro-description">
            Поєднуємо досвід наших фахівців, сучасний підхід і щиру турботу про пацієнтів.
          </p>
        </div>
        {canManageContent && <div className="presentationList_add">
          <AddActionButton onClick={presentationController.togglePresentationModal}/>
        </div>}
      </header>

      {isLoading && presentationItems.length === 0
        ? <div className="presentationList_skeletons" aria-label="Завантаження інформації">
          {[0, 1].map((item) => <div className="presentationList_skeleton" key={item}>
            <Skeleton.Image active/>
            <Skeleton active paragraph={{rows: 4}} title={{width: "65%"}}/>
          </div>)}
        </div>
        : presentationItems.length === 0
          ? <div className="presentationList_empty"><Empty description="Інформаційні матеріали ще не додано"/></div>
          : <div className={`presentationList_items ${isLoading ? "presentationList_items--updating" : ""}`}>
            {presentationItems.map((item, index) => (
          <PresentationListItem key={item.$id || index} presentationItem={item} index={index} presentationController={presentationController}/>
            ))}
          </div>}

      {isPresentationModalOpen && <PresentationModal presentationController={presentationController}/>}
    </section>
  );
};

export default PresentationList;
